import React, { useContext, useEffect, useState } from "react";
import { apiDelete, apiGet, apiPost, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { AiFillDelete, AiFillEdit, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort, BsHandThumbsUp } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { Link, NavLink } from "react-router-dom";
import OButton from "components/reusable/OButton";
import OInputField from "components/reusable/OInputField";
import { useForm } from "react-hook-form";
import OImage from "components/reusable/OImage";

const List = ({
  page,
  sort,
  setSort,
  list,
  fetchProperties,
  manager,
  paginationObj,
}) => {
  const { t } = useTranslation();
  const { user, config } = useContext(AuthContext);
  const notification = useToastContext();
  const [selectedProperty, setSelectedProperty] = useState([]);
  const [selectedPropertyAgent, setSelectedPropertyAgent] = useState([]);
  const [showAddModal, setAddModal] = useState(false);
  const [selctAllCheck, setSelectAllCheck] = useState(false);
  const [presentationUrl, setPresentationUrl] = useState(false);
  const [changeAgentModal, setChangeAgentModal] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });

  const setPropertyPrice = (item) => {
    const isRent = item?.propertyType?.includes("Rent");
    if (isRent) {
      if (item?.priceDaily) {
        return helper.priceFormat(item?.priceDaily) + " " + config?.currency;
      } else if (item?.priceWeekly) {
        return helper.priceFormat(item?.priceWeekly) + " " + config?.currency;
      } else if (item?.priceMonthly) {
        return helper.priceFormat(item?.priceMonthly) + " " + config?.currency;
      } else if (item?.priceYearly) {
        return helper.priceFormat(item?.priceYearly) + " " + config?.currency;
      } else {
        return "N/A";
      }
    } else if (item?.price) {
      return helper.priceFormat(item?.price) + " " + config?.currency;
    } else {
      return "N/A";
    }
  };

  const selectHandler = (data) => {
    const isExists = selectedProperty?.find((res) => res?._id === data?._id);
    if (!isExists) {
      setSelectedProperty([...selectedProperty, data]);
    } else {
      setSelectedProperty(
        selectedProperty.filter((item) => item?._id !== data?._id)
      );
    }
  };

  useEffect(() => {
    if (selectedProperty?.length !== list?.length) {
      setSelectAllCheck(false);
    }
  }, [selectedProperty]);

  useEffect(() => {
    setPresentationUrl("");
  }, [showAddModal]);

  const selctAllHandler = () => {
    setSelectAllCheck(!selctAllCheck);
    if (selectedProperty?.length === list?.length) {
      setSelectedProperty([]);
    } else setSelectedProperty(list?.map((res) => res));
  };

  const replaceUrl = (data) => {
    if (data) {
      const dbUrl = data?.split(config?.country === "Saudi" ? "o/" : "net/");
      data = dbUrl[1];
      return data;
    }
  };

  const createProposalHandler = async () => {
    try {
      let payload = [];
      selectedProperty?.forEach((element, i) => {
        let upadtedData = {};

        if (element?.isChangeAgent) {
          upadtedData = {
            propertiesId: element?._id,
            name: element?.agent?.firstName,
            email: element?.agent?.email,
            phone: element?.agent?.phone,
            designation: element?.agent?.designation,
            image: replaceUrl(element?.agent?.image),
          };
        } else {
          upadtedData = {
            propertiesId: element?._id,
            agentId: element?.agentId,
          };
        }
        payload.push(upadtedData);
      });
      // console.log("payload",payload);
      // return
      const path = apiPath.propertiesPromotions;
      const result = await apiPost(path, { properties: payload });
      if (result?.status === 200) {
        notification.success(result.data.message);
        setPresentationUrl(result?.data?.results?.url);
        fetchProperties();
        // setAddModal(false);
        // setSelectedProperty([]);
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  const selctChangeAgentHandler = (data) => {
    setSelectedPropertyAgent(data);
    setChangeAgentModal(!changeAgentModal);
  };

  const onSubmit = async (data) => {
    if (!profilePic) {
      notification.error(t("SELECT_IMAGE"));
      return;
    }
    setSelectedPropertyAgent([]);
    setValue("firstName", "");
    setValue("email", "");
    setValue("phone", "");
    setValue("designation", "");
    setValue("image", "");
    setProfilePic(null);

    setSelectedProperty(
      selectedProperty?.map((res) => {
        if (res?._id === selectedPropertyAgent?._id) {
          return {
            ...res,
            ...{ agent: { ...data, image: profilePic }, isChangeAgent: true },
          };
        } else return { ...res };
      })
    );
    setChangeAgentModal(false);
    setProfilePic(null);
  };

  const uploadTemporaryPhotos = async (e) => {
    const formData = new FormData();
    formData.append("image", e);
    const { data: response } = await apiPost(
      apiPath.uploadTemporaryPhotos,
      formData
    );
    if (response.success) {
      setProfilePic(response?.results?.image);
    } else {
      notification.error(response?.message);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("✅ Copied successfully ");
    } catch (e) {
      console.log("❌ Failed to copy (insufficient permissions) ");
    }
  };

  const handleProperty = (item) => {
    let property = {};
    if (!isEmpty(item?.unitDetails)) {
      property["_id"] = item?.unitDetails?._id;
      property["title"] = item?.unitDetails?.title;
      property["area"] = item?.unitDetails?.totalArea;
      property["price"] = item?.unitDetails?.price;
      property["slug"] = item?.unitDetails?.slug;
      property["createdAt"] = item?.createdAt;
      property["type"] = "Unit";
      return property;
    }

    if (!isEmpty(item?.propertyDetails)) {
      property["_id"] = item?.propertyDetails?._id;
      property["title"] = item?.propertyDetails?.title;
      property["area"] = item?.propertyDetails?.propertySize;
      property["price"] = item?.propertyDetails?.price;
      property["slug"] = item?.propertyDetails?.slug;
      property["propertyType"] =
        item?.propertyDetails?.propertyTypeDetails?.name;
      property["createdAt"] = item?.createdAt;
      property["type"] = "Property";
      return property;
    }

    return property;
  };

  const handlePropertyRedirect = (item) => {
    if (item.type === "Unit") {
      return `${process.env.REACT_APP_WEBSITE_BASE_URL}/project/${item.slug}`;
    }
    if (item.type === "Property") {
      return `${process.env.REACT_APP_WEBSITE_BASE_URL}/property/${item.slug}`;
    }
    return undefined;
  };

  const openOrderDetails = async (order) => {
    try {
      setViewLoading(true);
      setShowViewModal(true);
      setOrderDetails(null);
      const path = `${apiPath.orders}/${order?._id}`;
      const result = await apiGet(path);
      if (result?.data?.success) {
        setOrderDetails(result.data.results);
      } else {
        notification.error(
          result?.data?.message || t("O_SOMETHING_WENT_WRONG")
        );
      }
    } catch (e) {
      notification.error(e?.message || t("O_SOMETHING_WENT_WRONG"));
    } finally {
      setViewLoading(false);
    }
  };

  return (
    <>
      <div className="p-3">
        <div
          className="overflow-x-auto relative 
 border"
        >
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  <input
                    type="checkbox"
                    id="check"
                    name="selectAll"
                    checked={selctAllCheck}
                    onChange={() => selctAllHandler()}
                  />
                </th>
                <th scope="col" className="py-3 px-6">
                  #
                </th>

                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (sort.sortKey === "title" && sort.sortType === "asc") {
                      setSort({
                        sortKey: "title",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "title",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_PROPERTY_NAME")}</span>
                    <span>
                      {sort.sortKey === "title" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "title" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                {/* <th scope='col' className='py-3 px-6 text-center'>
                {t('O_NAME') + t('O_ARABIC')}
              </th> */}

                {/* <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'name',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'name',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_PROPERTY_CATEGORY')} </span>
                  <span>
                    {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th> */}
                <th
                  scope="col"
                  className="py-3 px-6  "
                  // onClick={() => {
                  //   if (
                  //     sort.sortKey === 'property_type' &&
                  //     sort.sortType === 'asc'
                  //   ) {
                  //     setSort({
                  //       sortKey: 'property_type',
                  //       sortType: 'desc'
                  //     })
                  //   } else {
                  //     setSort({
                  //       sortKey: 'property_type',
                  //       sortType: 'asc'
                  //     })
                  //   }
                  // }}
                >
                  <div className="flex">
                    <span>{t("O_PROPERTY_TYPE")} </span>
                    {/* <span>
                    {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span> */}
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "firstName" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "firstName",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "firstName",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_AGENT_NAME")} </span>
                    <span>
                      {sort.sortKey === "firstName" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "firstName" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>

                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (sort.sortKey === "price" && sort.sortType === "asc") {
                      setSort({
                        sortKey: "price",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "price",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("PRICE")} </span>
                    <span>
                      {sort.sortKey === "price" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "price" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6">
                  <div className="flex">
                    <span>{t("O_PROPERTY_SIZE")} </span>
                  </div>
                </th>

                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "createdAt" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_CREATED_AT")}</span>
                    <span>
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "createdAt" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list?.map((item, i) => (
                  <tr
                    key={i}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                  >
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      <input
                        type="checkbox"
                        id="check"
                        name="property"
                        value={item?._id}
                        checked={selectedProperty.find(
                          (res) => res?._id === item?._id
                        )}
                        onChange={() => selectHandler(item)}
                      />
                    </th>
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className="py-2 px-2 border-r text-DarkBlue ">
                      <NavLink
                        className="cursor-pointer"
                        to={
                          handleProperty(item)?.type === "Property"
                            ? `/properties/view/${handleProperty(item)?._id}`
                            : "/projects/viewNew"
                        }
                        state={{
                          item:
                            handleProperty(item)?.type === "Property"
                              ? item?.propertyDetails
                              : item?.unitDetails,
                          propertyId: handleProperty(item)?._id,
                        }}
                      >
                        {handleProperty(item)?.title || "N/A"}
                      </NavLink>
                    </td>
                    {/* <td className='py-2 px-2 border-r'>{item?.titleAr}</td> */}

                    {/* <td className='py-2 px-2 border-r'>
                    {item?.propertyCategory?.name}
                  </td> */}
                    <td className="py-2 px-2 border-r">
                      {handleProperty(item).type || "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">{`${
                      item?.userDetails?.fullName || "N/A"
                    }`}</td>
                    <td className="py-2 px-2 border-r">
                      {setPropertyPrice(handleProperty(item))}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {handleProperty(item)?.area
                        ? handleProperty(item)?.area + " " + config?.areaUnit
                        : "N/A"}
                    </td>

                    <td className="py-2 px-2 border-r">
                      {helper.dateFormat(handleProperty(item).createdAt) ||
                        "N/A"}
                    </td>

                    <td className="py-2 px-2 border-l">
                      <div className="">
                        <ul className="flex justify-center">
                          <li className="px-1 py-1 hover:bg-white hover:text-LightBlue">
                            <button
                              title={t("VIEW")}
                              onClick={() => openOrderDetails(item)}
                            >
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>

                    {/* <td className="py-2 px-2 border-l">
                      <div className="">
                        <ul className="flex justify-center">
                          <li className="px-1 py-1 hover:bg-white hover:text-LightBlue">
                            
                            <NavLink
                              to={`/properties/view/${item._id}`}
                              title={t('VIEW')}
                              state={{ item, propertyId: item?._id }}
                            >
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </td> */}
                  </tr>
                ))}
              {isEmpty(list) && (
                <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6" colSpan={16}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showAddModal && (
        <div className="modal">
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6  w-full max-w-[1150px] mx-auto">
              <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl font-semibold">
                      {t("CREATE_PROPERTY_PROPOSAL")}
                    </h3>
                    <button
                      className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                      onClick={() => {
                        setSelectedProperty([]);
                        setPresentationUrl(false);
                        setAddModal(!showAddModal);
                      }}
                    >
                      <span
                        className=" text-[#B8BBBF]  text-4xl "
                        title="Close"
                      >
                        ×
                      </span>
                    </button>
                  </div>

                  <div
                    className="overflow-x-auto relative 
 border m-3"
                  >
                    <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                      <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="py-3 px-6">
                            <div className="flex">
                              <span>{t("O_PROPERTY_NAME")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_PROPERTY_ID")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6  ">
                            <div className="flex">
                              <span>{t("O_PROPERTY_TYPE")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_AGENT_NAME")} </span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("PRICE")} </span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_PROPERTY_SIZE")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 text-center">
                            {t("CHANGE_AGENT")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedProperty &&
                          selectedProperty?.map((item) => {
                            return (
                              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                <th
                                  key={item?._id}
                                  scope="row"
                                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                                >
                                  {item?.title}
                                </th>
                                <td className="py-2 px-2 border-r">
                                  {item?.propertyId}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {item?.propertyType?.name}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {`${item?.agent?.firstName} ${
                                    item?.agent?.lastName
                                      ? item?.agent?.lastName
                                      : ""
                                  }`}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {setPropertyPrice(item)}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {item?.propertySize
                                    ? item?.propertySize +
                                      " " +
                                      config?.areaUnit
                                    : "N/A"}
                                </td>
                                <th scope="col" className="py-3 px-6">
                                  <input
                                    type="checkbox"
                                    id="change-agent"
                                    name="change-agent"
                                    value={item?._id}
                                    checked={
                                      selectedPropertyAgent?.length &&
                                      selectedPropertyAgent?.find(
                                        (res) => res?._id === item?._id
                                      )
                                    }
                                    onChange={() =>
                                      selctChangeAgentHandler(item)
                                    }
                                  />
                                </th>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {presentationUrl && (
                    <div className="flex items-center justify-between p-5 rounded-t">
                      <p className="text-s font-semibold">
                        Property presentation link:
                        <Link
                          to={presentationUrl}
                          target="_blank"
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            fontSize: 14,
                          }}
                        >
                          {`${presentationUrl}`}
                        </Link>
                      </p>
                      <div className="col-2 text-center ml-5">
                        <OButton
                          label={<>{t("COPY_URL")} </>}
                          type="button"
                          onClick={() => copyToClipboard(presentationUrl)}
                        />
                      </div>
                    </div>
                  )}

                  {!presentationUrl && (
                    <div className="col-2 text-center mb-5">
                      <OButton
                        label={<>{t("CREATE")} </>}
                        type="button"
                        onClick={() => createProposalHandler()}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </div>
      )}

      {changeAgentModal && (
        <div className="modal">
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6  w-full max-w-[1150px] mx-auto">
              <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl font-semibold">
                      {t("CHANGE_AGENT")}
                    </h3>
                    <button
                      className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                      onClick={() => setChangeAgentModal(!changeAgentModal)}
                    >
                      <span
                        className=" text-[#B8BBBF]  text-4xl "
                        title="Close"
                      >
                        ×
                      </span>
                    </button>
                  </div>

                  <div
                    className="overflow-x-auto relative 
 border m-3"
                  >
                    <div className="grid grid-rows-1 grid-cols-2 gap-4 p-3">
                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="firstName"
                          inputLabel={<>{t("O_FULL_NAME")}</>}
                          type="text"
                          autoFocus
                          register={register("firstName", {
                            required: "Please enter name",
                          })}
                          errors={errors}
                        />
                      </div>
                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="email"
                          inputLabel={<>{t("LOGIN_EMAIL")}</>}
                          type="text"
                          autoFocus
                          register={register("email", {
                            required: "Please enter email",
                          })}
                          errors={errors}
                        />
                      </div>

                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="phone"
                          inputLabel={<>{t("PHONE")}</>}
                          type="text"
                          autoFocus
                          register={register("phone", {
                            required: "Please enter phone",
                          })}
                          errors={errors}
                        />
                      </div>
                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="designation"
                          inputLabel={<>{t("AGENT_DESIGNATION")}</>}
                          type="text"
                          autoFocus
                          register={register("designation", {
                            required: "Please enter designation",
                          })}
                          errors={errors}
                        />
                      </div>

                      <div className="flex flex-col text-sm rounded-md">
                        <span className="flex align-center">
                          {t("UPLOAD_PROFILE_PICTURE")}
                        </span>
                        <input
                          type="file"
                          accept="image/png, image/jpg, image/jpeg"
                          name="profilePic"
                          onChange={(e) =>
                            uploadTemporaryPhotos(e?.target?.files[0])
                          }
                        />

                        {profilePic && (
                          <OImage
                            src={
                              profilePic
                              // ? URL.createObjectURL(profilePic)
                              // : ''
                            }
                            fallbackUrl="/images/user.png"
                            className="w-24 h-24 m-auto"
                            alt=""
                            style={{ borderRadius: "50%" }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-2 text-center mb-5">
                    <OButton
                      label={<>{t("O_ADD")}</>}
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </div>
      )}

      {showViewModal && (
        <div className="modal">
          <div
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            onClick={() => {
              setShowViewModal(false);
              setOrderDetails(null);
            }}
          >
            <div
              className="relative my-6  w-full max-w-[800px] mx-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="sm:py-4 sm:px-2 py-8 px-7 overflow-y-auto max-h-[90vh] ">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl font-semibold">{t("VIEW")} Order</h3>
                    <button
                      className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                      onClick={() => {
                        setShowViewModal(false);
                        setOrderDetails(null);
                      }}
                    >
                      <span
                        className=" text-[#B8BBBF]  text-4xl "
                        title="Close"
                      >
                        ×
                      </span>
                    </button>
                  </div>

                  <div className="p-5 text-sm">
                    {viewLoading && (
                      <div className="flex justify-center py-6">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                      </div>
                    )}
                    {!viewLoading && orderDetails && (
                      <div className="space-y-3">
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <span className="text-gray-500">Order ID:</span>{" "}
                            <span className="text-gray-900">
                              {orderDetails.orderId}
                            </span>
                          </div>
                          {orderDetails.paymentType && (
                            <div>
                              <span className="text-gray-500">
                                Payment Type:
                              </span>{" "}
                              <span className="text-gray-900">
                                {orderDetails.paymentType}
                              </span>
                            </div>
                          )}
                          <div>
                            <span className="text-gray-500">Created At:</span>{" "}
                            <span className="text-gray-900">
                              {helper.dateFormat(orderDetails.createdAt)}
                            </span>
                          </div>
                          <div>
                            <span className="text-gray-500">Subject Type:</span>{" "}
                            <span className="text-gray-900">
                              {orderDetails.subjectType}
                            </span>
                          </div>
                        </div>

                        {orderDetails.subjectType === "property" && (
                          <div className="mt-4 border-t pt-4">
                            <h4 className="font-semibold text-gray-900 mb-2">
                              Property
                            </h4>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <span className="text-gray-500">Title:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.subject?.title}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Type:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.subject?.propertyType?.name}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Price:</span>{" "}
                                <span className="text-gray-900">
                                  {helper.priceFormat(
                                    orderDetails.subject?.price
                                  )}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Status:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.subject?.status}
                                </span>
                              </div>
                              <div className="col-span-2">
                                <span className="text-gray-500">Address:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.subject?.address}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        {orderDetails.subjectType === "unit" && (
                          <div className="mt-4 border-t pt-4">
                            <h4 className="font-semibold text-gray-900 mb-2">
                              Unit
                            </h4>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <span className="text-gray-500">Unit No:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.subject?.unitNumber}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Cost:</span>{" "}
                                <span className="text-gray-900">
                                  {helper.priceFormat(
                                    orderDetails.subject?.cost
                                  )}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Status:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.subject?.status}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Project:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.subject?.project?.title}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        {orderDetails.customerInfo && (
                          <div className="mt-4 border-t pt-4">
                            <h4 className="font-semibold text-gray-900 mb-2">
                              Customer
                            </h4>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <span className="text-gray-500">Name:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.customerInfo?.customerName}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Mobile:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.customerInfo?.mobileNumber}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">
                                  National ID:
                                </span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.customerInfo?.nationalId}
                                </span>
                              </div>
                              <div>
                                <span className="text-gray-500">Email:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.customerInfo?.email}
                                </span>
                              </div>
                              <div className="col-span-2">
                                <span className="text-gray-500">Address:</span>{" "}
                                <span className="text-gray-900">
                                  {orderDetails.customerInfo?.address}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        {orderDetails.agent && (
                          <div className="mt-4 border-t pt-4">
                            <h4 className="font-semibold text-gray-900 mb-2">
                              Agent
                            </h4>
                            <div className="grid grid-cols-2 gap-4">
                              {orderDetails.agent?.name && (
                                <div>
                                  <span className="text-gray-500">Name:</span>{" "}
                                  <span className="text-gray-900">
                                    {orderDetails.agent?.name}
                                  </span>
                                </div>
                              )}
                              {orderDetails.agent?.email && (
                                <div>
                                  <span className="text-gray-500">Email:</span>{" "}
                                  <span className="text-gray-900">
                                    {orderDetails.agent?.email}
                                  </span>
                                </div>
                              )}
                              {orderDetails.agent?.mobile && (
                                <div>
                                  <span className="text-gray-500">Mobile:</span>{" "}
                                  <span className="text-gray-900">
                                    {orderDetails.agent?.mobile}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                        {orderDetails?.documents?.nationalAddress &&
                          orderDetails?.documents?.nationalAddress?.length >
                            0 && (
                            <div className="mt-4 border-t pt-4">
                              <h4 className="font-semibold text-gray-900 mb-2">
                                National Address
                              </h4>
                              <div className="flex gap-2 flex-wrap">
                                {orderDetails?.documents?.nationalAddress?.map(
                                  (address, index) => (
                                    <Link
                                      to={address.value}
                                      className=" hover:text-blue-500 p-3 rounded-md border border-gray-300 bg-green-400 text-white"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Address {index + 1}
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        {orderDetails?.documents?.nationalId &&
                          orderDetails?.documents?.nationalId?.length > 0 && (
                            <div className="mt-4 border-t pt-4">
                              <h4 className="font-semibold text-gray-900 mb-2">
                                National ID/s
                              </h4>
                              <div className="flex gap-2 flex-wrap">
                                {orderDetails?.documents?.nationalId?.map(
                                  (address, index) => (
                                    <Link
                                      to={address.value}
                                      className=" hover:text-blue-500 p-3 rounded-md border border-gray-300 bg-green-400 text-white"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      National ID {index + 1}
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        {orderDetails?.documents?.otherDocuments &&
                          orderDetails?.documents?.otherDocuments?.length >
                            0 && (
                            <div className="mt-4 border-t pt-4">
                              <h4 className="font-semibold text-gray-900 mb-2">
                                Other Documents
                              </h4>
                              <div className="flex gap-2 flex-wrap">
                                {orderDetails?.documents?.otherDocuments?.map(
                                  (address, index) => (
                                    <Link
                                      to={address.value}
                                      className=" hover:text-blue-500 p-3 rounded-md border border-gray-300 bg-green-400 text-white"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Document {index + 1}
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        {orderDetails?.documents?.receipts &&
                          orderDetails?.documents?.receipts?.length > 0 && (
                            <div className="mt-4 border-t pt-4">
                              <h4 className="font-semibold text-gray-900 mb-2">
                                Receipts
                              </h4>
                              <div className="flex gap-2 flex-wrap">
                                {orderDetails?.documents?.receipts?.map(
                                  (address, index) => (
                                    <Link
                                      to={address.value}
                                      className=" hover:text-blue-500 p-3 rounded-md border border-gray-300 bg-green-400 text-white"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Receipt {index + 1}
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="opacity-25 fixed inset-0 z-40 bg-black"
            onClick={() => {
              setShowViewModal(false);
              setOrderDetails(null);
            }}
          />
        </div>
      )}
    </>
  );
};

export default List;
